/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_New_MeasurementInputs */

const en_us2_profile_new_measurement = /** @type {(inputs: Profile_New_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New measurement`)
};

const pt_br2_profile_new_measurement = /** @type {(inputs: Profile_New_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova medida`)
};

const es_419_profile_new_measurement = /** @type {(inputs: Profile_New_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nueva medición`)
};

const pt_pt2_profile_new_measurement = /** @type {(inputs: Profile_New_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova medição`)
};

const fr_fr2_profile_new_measurement = /** @type {(inputs: Profile_New_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle mesure`)
};

const de_de2_profile_new_measurement = /** @type {(inputs: Profile_New_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Messung`)
};

const it_it2_profile_new_measurement = /** @type {(inputs: Profile_New_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova misurazione`)
};

/**
* | output |
* | --- |
* | "New measurement" |
*
* @param {Profile_New_MeasurementInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_new_measurement = /** @type {((inputs?: Profile_New_MeasurementInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_New_MeasurementInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_new_measurement(inputs)
	if (locale === "es-419") return es_419_profile_new_measurement(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_new_measurement(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_new_measurement(inputs)
	if (locale === "de-DE") return de_de2_profile_new_measurement(inputs)
	if (locale === "it-IT") return it_it2_profile_new_measurement(inputs)
	return en_us2_profile_new_measurement(inputs)
});
export { profile_new_measurement as "profile.new_measurement" }